import Endpoint from "../../services/api/endpoint";
import { ISupplier } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<ISupplier>(Endpoint.Suppliers, Endpoint.SuppliersList);